import { createContext } from 'react';

import { IOpenBrokerModalParams } from '../../types/microfrontends/newbuildingBrokerWidget';

/* istanbul ignore next */
export const NewbuildingBrokerWidgetContext = createContext<(params: IOpenBrokerModalParams) => Promise<void>>(() =>
  Promise.resolve(),
);
